import { Controller } from "@hotwired/stimulus"

export default class CoreuiModalControlController extends Controller {
  static outlets = ["coreui-modal"]

  toggle(event) {
    this.coreuiModalOutlets.forEach((owner) => owner.toggle(event))
  }

  show(event) {
    this.coreuiModalOutlets.forEach((owner) => owner.show(event))
  }

  hide() {
    this.coreuiModalOutlets.forEach((owner) => owner.hide())
  }
}
